export function addPls (option, inputType) {
  let text1
  if (inputType === 'input') {
    text1 = 'i18n_please_enter'
  } else {
    text1 = 'i18n_please_choose'
  }
  return this.$t(text1) + this.$t(option)
}

export function cannotBeEmpty (option) {
  return this.$t(option) + ' ' + this.$t('i18n_cannot_be_empty')
}


// WEBPACK FOOTER //
// ./src/utils/placeholderI18n.js